module.exports = __webpack_public_path__ + "static/media/bg10.c036a284.jpg";